import React from "react";
import { useAuth } from "../Providers/AuthProvider";
import { NavBar } from "./NavBar";
import Footer from "./footer/Footer";

function WrapperComp({
  children,
  classes = null,
  customContainer,
  disableBackground,
}) {
  const { userInfo } = useAuth();
  return (
    <div
      key={userInfo.userid}
      className={classes}
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        background: disableBackground ? null : "#f5f5f5",
      }}
    >
      <div
        style={{
          flex: 1,
          width: "100%",
        }}
      >
        <NavBar />

        {customContainer ? (
          <>{children}</>
        ) : (
          <div className="mx-auto max-w-[1500px] mt-24">{children}</div>
        )}
      </div>
      <div
        style={{
          position: "relative",
          width: "100%",
        }}
      >
        <Footer />
      </div>
    </div>
  );
}

export default WrapperComp;
